
import Vue from 'vue';
import {
  Wrapper, TabsHeader, TabsList, LineTab,
} from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    TabsHeader,
    TabsList,
    LineTab,
  },
  props: {
    showLine: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Boolean,
      default: false,
    },
    itemPix: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      tabs: [] as any,
    };
  },
  methods: {
    selectTab(index: number) {
      this.selectedIndex = index;
      this.tabs.forEach((tab: any, i: number) => {
        const item = tab;
        item.isActive = i === index;
      });
    },
  },
  async mounted() {
    const elWrapper = this.$refs.wrapper as Vue;

    this.tabs = elWrapper.$children.splice(1).map((tab: any, index: number) => {
      if (index === 0) {
        const item = tab;
        item.isActive = true;
        return item;
      }

      return tab;
    });
  },
});
